/* Blokkie theme — vanilla JS
   - Globale kleurkeuze: één <body data-color> stuurt alle live-recolor renders.
   - Per form: hidden variant-id + prijslabel updaten uit de embedded variant-map.
   - PDP-gallery: thumbnail wisselt de actieve view.
   Geen framework, geen dependencies. Alles degradeert netjes zonder JS. */
(function () {
  'use strict';

  // Kleur-keys + weergave-labels komen uit het product (via de swatch-inputs:
  // value=key, data-label=weergavetekst). Geen hardcoded kleurenlijst hier.
  var state = { color: 'wit' };

  function forms() { return Array.prototype.slice.call(document.querySelectorAll('[data-bk-form]')); }

  function currentQty(form) {
    var checked = form.querySelector('[data-bk-qty-input]:checked');
    if (checked) { return checked.value; }
    return form.getAttribute('data-bk-qty') || 'tegel';
  }

  function updateForm(form) {
    var map = form.__bkMap;
    if (!map) { return; }
    var entry = map[state.color + '|' + currentQty(form)];
    if (!entry) { return; }
    var id = form.querySelector('[data-bk-id]');
    if (id) { id.value = entry.id; }
    Array.prototype.forEach.call(form.querySelectorAll('[data-bk-price]'), function (el) {
      el.textContent = entry.price;
    });
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = entry.available === false;
      if (entry.available === false) { btn.setAttribute('aria-disabled', 'true'); }
      else { btn.removeAttribute('aria-disabled'); }
    }
  }

  function setColor(key) {
    if (!key) { return; }
    state.color = key;
    document.body.setAttribute('data-color', key);
    // sync alle kleur-radiogroepen + haal het weergave-label uit de gekozen swatch
    var label = '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-bk-color-input]'), function (inp) {
      var match = inp.value === key;
      inp.checked = match;
      if (match) { label = inp.getAttribute('data-label') || label; }
    });
    if (label) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bk-color-label]'), function (el) {
        el.textContent = label;
      });
    }
    forms().forEach(updateForm);
  }

  function initForms() {
    forms().forEach(function (form) {
      var script = form.querySelector('[data-bk-variants]');
      if (script) {
        try { form.__bkMap = JSON.parse(script.textContent); } catch (e) { form.__bkMap = null; }
      }
      Array.prototype.forEach.call(form.querySelectorAll('[data-bk-qty-input]'), function (inp) {
        inp.addEventListener('change', function () { updateForm(form); });
      });
    });
  }

  function initColorInputs() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bk-color-input]'), function (inp) {
      inp.addEventListener('change', function () { setColor(inp.value); });
    });
  }

  function initGallery() {
    var gallery = document.querySelector('[data-bk-gallery]');
    if (!gallery) { return; }
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-bk-thumb]'));
    var views = Array.prototype.slice.call(gallery.querySelectorAll('[data-bk-view]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = thumb.getAttribute('data-bk-thumb');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        views.forEach(function (v) { v.classList.toggle('is-active', v.getAttribute('data-bk-view') === i); });
      });
    });
  }

  function initCart() {
    // Winkelmand-stepper/remove: AJAX via de officiële /cart/change.js, met de
    // href als nette no-JS fallback. Na wijziging herladen (statisch & solide).
    Array.prototype.forEach.call(document.querySelectorAll('[data-bk-cart-change]'), function (link) {
      link.addEventListener('click', function (e) {
        if (link.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: link.getAttribute('data-bk-key'), quantity: parseInt(link.getAttribute('data-bk-qty'), 10) })
        }).then(function () { window.location.reload(); })
          .catch(function () { window.location.href = link.href; });
      });
    });
  }

  function init() {
    initColorInputs();
    initForms();
    // begintoestand: pak een reeds-gekozen kleur, anders <body data-color>, anders 'oranje'
    var checked = document.querySelector('[data-bk-color-input]:checked');
    setColor(checked ? checked.value : (document.body.getAttribute('data-color') || 'wit'));
    initGallery();
    initCart();
    initDiscount();
  }

  function initDiscount() {
    // Kortingscode toepassen via de officiële /discount/{code}-route: past 'm toe
    // op de winkelmand én neemt 'm mee naar de checkout.
    var input = document.querySelector('[data-bk-discount-input]');
    var apply = document.querySelector('[data-bk-discount-apply]');
    if (!input || !apply) { return; }
    function go() {
      var code = input.value.trim();
      if (!code) { input.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    }
    apply.addEventListener('click', go);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); go(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
